import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FlowProvider,
  FlowRunner,
  FlowTypes,
  setFlowDataDirect,
  useFlowController,
  ProductReview,
  LabelWithCondition,
  TextMask,
  getFlowPathData,
  getFlowDataDirect,
  getGuid,
  saveCountVisit,
  getSavedCover,
  handleSendKlaviyoEvents,
} from "@adaptis/flow-components";
// import PetsyComponents from './pages/PetsyComponents';
import flowConfig from "./flow-config.json";
import helperText from "./helper-text.json";
import BreedChooser from "./components/BreedChooser";
import PetQuantity from "./components/PetQuantity";
import CoveredPet from "./components/CoveredPet";
import CoveredPetGroup from "./components/CoveredPetGroup";
import SelectedCover from "./components/SelectedCover";
import SelectedCoverSummary from "./components/SelectedCoverSummary";
import SelectCover from "./components/SelectCover";
import AmountPayable from "./components/AmountPayable";
import PetSuburbPCLookup from "./components/PetSuburbPCLookup";
import FeatureLabel from "./components/FeatureLabel";
import PetPayment from "./components/PetPayment";
import PetPaymentSummary from "./components/PetPaymentSummary";
import PetsyHeading from "./components/PetsyHeading";
import PetsyCoverSummary from "./components/PetsyCoverSummary";
import SuccessHeader from "./components/SuccessHeader";
import Coupon from "./components/Coupon";
import CoverOptionsSection from "./components/CoverOptionsSection";
import LoadQuote from "./components/LoadQuote";
import SaveQuote from "./components/SaveQuote";
import appConfig from "./app-config";
import { addNewPet, loadSavedQuote, setPetOriginalModel, getPromocode } from "./util/data-store";
import _ from "./imports/lodash-imports";
import { PetType } from "./util/common-types";
import { tips } from "./components/PopupTips/tips";
import NoSubLimitBanner from "./components/NoSubLimitBanner";
import NoSubLimitsBanner2 from "./components/NoSubLimitsBanner2";
import PetImageHeader from "./components/PetImageHeader";
import PetsyFeatureLabelGroup from "./components/PetsyFeatureLabelGroup";
import PetPaymentSummaryBanner from "./components/PetPaymentSummaryBanner";
import PetsyPaymentFrequency from "./components/PetsyPaymentFrequency";
import ApplyCoupon from "./components/ApplyCoupon";
import PetsyQuoteNumber from "./components/PetsyQuoteNumber";
import { pushDataToGTM, getPetAge } from "./KnoseAPI/Lib/Utils";
import { getGTMQuoteData, getAFXProfile } from "./util/helper-functions";
import PetsyTracker from "./components/PetsyTracker";
import PetsyBonusTracker from "./components/PetsyBonusTracker";
import PetsyAnnualLimitBonusApplied from "./components/PetsyAnnualLimitBonusApplied";
import PetsyExclusionPeriods from "./components/PetsyExclusionPeriods";
import PetsyP from "./components/PetsyP";
import PetsyExpiredPopup from "./components/PetsyExpiredPopup";
import PetsyRefPopup from "./components/PetsyRefPopup";
import PetsyHelpPopup from "./components/PetsyHelpPopup";
import PetsyRetrieveQuotePopup from "./components/PetsyRetrieveQuotePopups";
import PetsySavedQuoteErrorPopup from "./components/PetsySavedQuoteErrorPopup";
import PetsyTableGreenBoxes from "./components/PetsyTableGreenBoxes";
import PetsyHelperTexts from "./components/PetsyHelperTexts";
import { getCustomerInfo, getSalesJourneyInfo } from "./util/knose-api-wrapper";
import LoadingLightbox from "./components/LoadingLightbox";
import moment from "dayjs";
function App(): React.ReactElement {
  const location = useLocation();
  const { gotoStep } = useFlowController();
  const [devState, setDevState] = useState<number>(0);
  const [modalShowIsExpired, setModalShowIsExpired] = React.useState(false);
  const [modalShowSavedQuotePopup, setModalShowSavedQuotePopup] = React.useState(false);
  const [modalShowRetrieveQuotePopup, setModalShowRetrieveQuotePopup] = React.useState(false);
  const [modalShowRefPopup, setModalShowRefPopup] = React.useState(false);
  const [sessionData, setSessionData] = React.useState(null);
  const [quoteNumberField, setQuoteNumberField] = React.useState("");
  const petsyComponents: FlowTypes.IFlowComponentList = [
    { name: "BreedChooser", type: BreedChooser },
    { name: "PetQuantity", type: PetQuantity },
    { name: "CoveredPet", type: CoveredPet },
    { name: "CoveredPetGroup", type: CoveredPetGroup },
    { name: "SelectedCover", type: SelectedCover },
    { name: "SelectCover", type: SelectCover },
    { name: "SelectedCoverSummary", type: SelectedCoverSummary },
    { name: "AmountPayable", type: AmountPayable },
    { name: "FeatureLabel", type: FeatureLabel },
    { name: "PetSuburbPCLookup", type: PetSuburbPCLookup },
    { name: "PetPayment", type: PetPayment },
    { name: "PetPaymentSummary", type: PetPaymentSummary },
    { name: "PetsyHeading", type: PetsyHeading },
    { name: "PetsyCoverSummary", type: PetsyCoverSummary },
    { name: "SuccessHeader", type: SuccessHeader },
    { name: "Coupon", type: Coupon },
    { name: "CoverOptionsSection", type: CoverOptionsSection },
    { name: "LoadQuote", type: LoadQuote },
    { name: "SaveQuote", type: SaveQuote },
    { name: "NoSubLimitBanner", type: NoSubLimitBanner },
    { name: "NoSubLimitsBanner2", type: NoSubLimitsBanner2 },
    { name: "ProductReview", type: ProductReview },
    { name: "PetImageHeader", type: PetImageHeader },
    { name: "PetsyFeatureLabelGroup", type: PetsyFeatureLabelGroup },
    { name: "PetPaymentSummaryBanner", type: PetPaymentSummaryBanner },
    { name: "PetsyPaymentFrequency", type: PetsyPaymentFrequency },
    { name: "ApplyCoupon", type: ApplyCoupon },
    { name: "PetsyQuoteNumber", type: PetsyQuoteNumber },
    { name: "LabelWithCondition", type: LabelWithCondition },
    { name: "TextMask", type: TextMask },
    { name: "PetsyTracker", type: PetsyTracker },
    { name: "PetsyBonusTracker", type: PetsyBonusTracker },
    { name: "PetsyAnnualLimitBonusApplied", type: PetsyAnnualLimitBonusApplied },
    { name: "PetsyExclusionPeriods", type: PetsyExclusionPeriods },
    { name: "PetsyP", type: PetsyP },
    { name: "PetsyExpiredPopup", type: PetsyExpiredPopup },
    { name: "PetsyTableGreenBoxes", type: PetsyTableGreenBoxes },
    { name: "PetsyHelperTexts", type: PetsyHelperTexts },
    { name: "PetsyHelpPopup", type: PetsyHelpPopup },
  ];

  function handleFlowStart() {
    console.log("Flow started");
    processUrlParams();
  }

  async function processUrlParams() {
    const query = new URLSearchParams(location.search);
    // Lead source
    const leadSource = query.get("lsid");
    if (leadSource) {
      setFlowDataDirect("leadSource", leadSource);
    }

    // promo code
    const coupon = query.get("coupon");
    if (coupon) {
      console.log("Start - " + coupon);
      setFlowDataDirect("leadSource", leadSource);
      setLoadingPrice(true);
      let filteredPromoCode: any = await getPromocode(coupon);
      if (!filteredPromoCode) {
        setFlowDataDirect("promoCode", null);
      } else {
        let selectedPromotionCode: FlowTypes.IFlowPromotionCode = {
          promoCode: coupon,
          promotionMessage: filteredPromoCode.promotionMessage,
          campaignName: filteredPromoCode.campaignName,
          type: filteredPromoCode.type
            ? parseInt(filteredPromoCode.type.replace("Type", ""))
            : undefined,
          imgSrc: filteredPromoCode.imagePath,
          percent: filteredPromoCode.discount,
          period: filteredPromoCode.period,
          discount: filteredPromoCode.discount,
        };
        await setFlowDataDirect("selectedPromoCode", selectedPromotionCode);
        await setFlowDataDirect("promoCode", coupon.toUpperCase());
        await setFlowDataDirect("promoCodeType", selectedPromotionCode.type);
      }
    }
    let sessionId = getFlowDataDirect("sessionId");
    // save count visits
    let localPath = location.pathname;
    localPath = localPath.endsWith("/") ? localPath.slice(0, -1) : localPath;
    localPath = localPath.replace("/step-1", "");
    // send klaviyo event
    await handleSendKlaviyoEvents("Initial_Page", [{ url: location.pathname }]);
    if (location.pathname.includes("step-1/ref")) {
      if (location.search) {
        localPath += location.search;
      }
      try {
        setModalShowRefPopup(true);
        let afxProfile = getAFXProfile();
        saveCountVisit({
          url: localPath,
          sessionId,
          adfixusID: afxProfile !== "(not set)" ? afxProfile : "",
        });
      } catch (error) {}
    }

    // Function
    const functionName = query.get("fn");
    const sdid = query.get("sdid");
    const vers = query.get("v");
    const fdclid = query.get("fdclid") ?? "";
    setFlowDataDirect("fdclid", fdclid);
    let isLookUp = false;
    // console.log("PPP-161=0: ", sdid);
    if (sdid) {
      await handlePopulateSavedCover(sdid, vers ?? "", coupon);
    }
    // Quote lookup: /step-1/?fn=quote-lookup&q=[valid quote number]
    else if (functionName === "quote-lookup") {
      const quoteNo = query.get("q");
      if (quoteNo) {
        setLoadingPrice(true);
        isLookUp = true;
        const quoteFoundAndLoaded = await loadSavedQuote(quoteNo);
        // console.log("quoteFoundAndLoaded :>> ", quoteFoundAndLoaded);
        setLoadingPrice(false);
        if (quoteFoundAndLoaded) {
          setFlowDataDirect("quoteNo", quoteNo);
          gotoStep("step-2");
        }
      }
      // test
      ///?fn=quote-lookup&ec=119234&pj=23041039730&cp=2
      const salesJourneyId = query.get("pj");
      const customerId = query.get("ec");

      if (salesJourneyId && customerId) {
        setLoadingPrice(true);
        setFlowDataDirect("salesJourneyId", salesJourneyId);
        setFlowDataDirect("customerId", customerId);
        setFlowDataDirect("TransferQuoteCallBack", "Yes");
        //setDevState((state) => state + 1);
        setTimeout(() => {
          setLoadingPrice(true);
          TransferQuoteCallBack();
        }, 1000);
      }
    }

    let afxProfile = getAFXProfile();
    // console.log("[PPP-173] afxProfile: ", afxProfile);
    // setModalShowRetrieveQuotePopup(true);
    if (!sdid && afxProfile && afxProfile !== "(not set)" && !isLookUp) {
      let quoteData = localStorage.getItem(afxProfile);
      // console.log("[PPP-173] quoteData: ", quoteData);
      let daysAccepted = 30;

      if (quoteData) {
        let quoteDataObj = JSON.parse(quoteData);
        let addedAt = Number(quoteDataObj.addedAt);

        // Nếu đã quá 30 ngày thì xóa record và chuyển về /step-1
        if (
          !quoteDataObj.quoteNumber ||
          !addedAt ||
          addedAt <= Date.now() - 1000 * 60 * 60 * 24 * daysAccepted
        ) {
          // console.log("[PPP-173] removeItem: ", addedAt, addedAt <= Date.now() - 1000 * 60 * 60 * 24 * daysAccepted);
          localStorage.removeItem(afxProfile);
          // Không show popup
        } else {
          // console.log("[PPP-173] quoteDataObj.quoteNumber: ", quoteDataObj.quoteNumber);
          setQuoteNumberField(quoteDataObj.quoteNumber);
          // Nếu còn hạn thì show popup và pre-populate quote number
          setModalShowRetrieveQuotePopup(true);
        }
      }
    }
    // else{
    //   setQuoteNumberField("P45357790")
    //   // setQuoteNumberField("P12342305");
    //   setModalShowRetrieveQuotePopup(true);
    // }

    setLoadingPrice(false);
  }

  async function handlePopulateSavedCover(sdid: string, vers?: string, currentCoupon?: any) {
    sdid = sdid.trim().toLocaleUpperCase();
    vers = vers ? vers.trim().toLocaleUpperCase() : "";
    // let isLastest = vers ? false : true;
    setLoadingPrice(true);

    let saveCoverData = await getSavedCover(vers ? vers : sdid);
    if (saveCoverData) {
      handleRetrieveQuote(vers ? vers : sdid, saveCoverData);
    } else {
      setModalShowSavedQuotePopup(true);
    }
    setLoadingPrice(false);
  }

  async function handleRetrieveQuote(quoteInitialValue: string, saveCoverData: any) {
    // console.log("[PPP-173] handleRetrieveQuote: ", quoteInitialValue, saveCoverData);
    let sdid = quoteInitialValue;
    let vers = "";
    // console.log("[PPP-173] quoteInitialValue: ", quoteInitialValue, saveCoverData.parrentId);
    if (saveCoverData.parrentId && quoteInitialValue !== saveCoverData.parrentId) {
      // console.log("[PPP-173] vao day 1: ");
      vers = quoteInitialValue;
      sdid = saveCoverData.parrentId;
    }
    // console.log("[PPP-173] sdid 0: ", sdid);
    // console.log("[PPP-173] vers 0: ", vers);
    var flowDataStore: any = await getFlowPathData();

    setLoadingPrice(true);
    let { holderAddress, pets, promoCode, promoType } = saveCoverData;

    // console.log("[PPP-173] sdid 1: ", sdid);
    // console.log("[PPP-173] vers 1: ", vers);
    setFlowDataDirect("sessionId", getGuid());
    setFlowDataDirect("pets", []);
    //Set customer information
    setFlowDataDirect("holderFirstName", saveCoverData.holderFirstName);
    setFlowDataDirect("holderLastName", saveCoverData.holderLastName ?? "");
    setFlowDataDirect(
      "holderPhone",
      saveCoverData.holderPhone ? saveCoverData.holderPhone.replace("+61", "0") : "",
    );
    setFlowDataDirect("holderEmail", saveCoverData.holderEmail);
    setFlowDataDirect("holderDOB", saveCoverData.holderDOB ?? "");

    setFlowDataDirect("refs", null);

    setFlowDataDirect("holderAddress", {
      line1: holderAddress.line1,
      line2: holderAddress.line2 ?? "",
      suburb: holderAddress.suburb,
      state: holderAddress.state,
      postcode: holderAddress.postcode,
    });
    let petTypesChosen: any[] = [];
    // console.log("PPP-161 pets", pets);
    _.set(flowDataStore, "petQty", pets.length);
    _.set(flowDataStore, "isSavedQuote", true);
    _.set(flowDataStore, "isChangedData", false);
    _.set(flowDataStore, "petsyQuoteNumber", vers ? vers : sdid);
    _.set(flowDataStore, "parentQuoteNumber", sdid);
    _.set(flowDataStore, "quoteNumber", vers ? vers : sdid);

    pets.forEach((pet: any) => {
      if (pet.startDate && moment(pet.startDate).isBefore(moment(), "day")) {
        pet.startDate = moment().format("YYYY-MM-DD"); // gán lại ngày hiện tại
      }
    });

    // console.log("[Debug] sdid: ", sdid);
    // console.log("[Debug] vers: ", vers);
    // console.log("[Debug] saveCoverData: ", saveCoverData);

    let allPetNames: string[] = [];
    for (const [index, pet] of pets.entries()) {
      let { customCover } = pet;
      let petType = pet.petType.toLowerCase();
      if (petType == "dog") addNewPet(getFlowDataDirect("pets"), PetType.Dog);
      else addNewPet(getFlowDataDirect("pets"), PetType.Cat);
      petTypesChosen.push(petType);
      let assignedPets = await getFlowDataDirect("pets");
      allPetNames.push(pet.name);
      _.assign(assignedPets[index], {
        pet_no: pet.pet_no || index,
        name: pet.name,
        isValid: false,
        isTouched: true,
        breed: pet.breed,
        petDOB: pet.petDOB,
        startDate: pet.startDate,
        petSex: pet.petSex.toLowerCase(),
        isDesexed: pet.isDesexed,
        petAgeCategory: pet.petAgeCategory,
        petAgeOnStartDatePolicy: pet.petAgeOnStartDatePolicy,
        pet_refs: pet.pet_refs ?? {
          callReferenceId: moment().unix().toString(),
        },
        id: getGuid(),
        coverType: "custom",
        customCover: {
          quoteNumber: vers ? vers : sdid,
          parentQuoteNumber: sdid,
          paymentFrequency: "monthly",
          annualBenefitLimit: customCover.annualBenefitLimit,
          benefitPercentage: customCover.benefitPercentage,
          annualExcess: customCover.annualExcess,
          optionalExtras: customCover.optionalExtras,
          vetConsultationFees: customCover.vetConsultationFees,
          hasQuote: true,
          // premiums: customCover.premiums ?? null,
          // promo: customCover.promo ?? null,
          promoCode: customCover.promoCode ?? null,
        },
      });
    }

    setLoadingPrice(true);
    let filteredPromoCode: any = null;
    if (promoCode) {
      filteredPromoCode = await getPromocode(promoCode);
    }

    if (filteredPromoCode) {
      let selectedPromotionCode: FlowTypes.IFlowPromotionCode = {
        promoCode: promoCode,
        promotionMessage: filteredPromoCode.promotionMessage,
        campaignName: filteredPromoCode.campaignName,
        type: filteredPromoCode.type
          ? parseInt(filteredPromoCode.type.replace("Type", ""))
          : undefined,
        imgSrc: filteredPromoCode.imagePath,
        percent: filteredPromoCode.discount,
        period: filteredPromoCode.period,
        discount: filteredPromoCode.discount,
      };
      _.set(flowDataStore, "selectedPromoCode", selectedPromotionCode);
      _.set(flowDataStore, "promoCode", promoCode);
      _.set(
        flowDataStore,
        "promoCodeType",
        promoType ? parseInt(promoType.replace("Type", "")) : "",
      );
    }
    _.set(flowDataStore, "PetTypeChosenFirst", petTypesChosen[0]);
    _.set(flowDataStore, "PetTypesChosen", petTypesChosen);
    _.set(flowDataStore, "totalAmounts.allPetNames", allPetNames.join(","));
    _.set(flowDataStore, "totalAmounts.installmentAmount", "0");
    _.set(flowDataStore, "totalAmounts.installmentBasePremium", "0");
    _.set(flowDataStore, "totalAmounts.installmentBasePremiumPlusGST", "0");
    _.set(flowDataStore, "totalAmounts.installmentStampDuty", "0");
    _.set(flowDataStore, "totalAmounts.installmentPolicyFee", "0");
    _.set(flowDataStore, "totalAmounts.installmentPolicyFeeTotal", "0");
    _.set(flowDataStore, "totalAmounts.totalInstallmentDiscountAmount", "0");

    setLoadingPrice(false);
    let nextStep = "/custom-cover/" + getFlowDataDirect("pets[0].id");
    gotoStep(nextStep);
  }

  function OnClosePoupCallback() {
    setModalShowIsExpired(false);
    setModalShowSavedQuotePopup(false);
    setModalShowRefPopup(false);
    setModalShowRetrieveQuotePopup(false);
  }

  function OnClosePoupCallbackRetrieveQuote(quoteInitialValue: string, saveCoverData?: any) {
    // console.log("[PPP-173] OnClosePoupCallbackRetrieveQuote: ", saveCoverData);
    setModalShowRetrieveQuotePopup(false);
    if (saveCoverData) {
      // console.log("[PPP-173] OnClosePoupCallbackRetrieveQuote: ", quoteInitialValue, saveCoverData);
      handleRetrieveQuote(quoteInitialValue, saveCoverData);
    }
  }

  function TransferQuoteCallBack() {
    setFlowDataDirect("selectedRetrieveQuoteMethod", "enterQuoteNumber");
    let salesJourneyId = getFlowDataDirect("salesJourneyId");
    let customerId = getFlowDataDirect("customerId");
    if (salesJourneyId && customerId) {
      CallTransferQuoteCallBack(salesJourneyId, customerId);
    }
  }

  async function CallTransferQuoteCallBack(salesJourneyId: any, customerId: any) {
    try {
      const resultCustomerInfo = await getCustomerInfo(salesJourneyId, customerId);
      if (resultCustomerInfo) {
        if (resultCustomerInfo.data) {
          populateTransferQuoteDetailsMM(resultCustomerInfo.data);

          setLoadingPrice(false);
          setFlowDataDirect("salesJourneyId", "");
          if (
            resultCustomerInfo.data &&
            resultCustomerInfo.data.input &&
            resultCustomerInfo.data.input.refs &&
            resultCustomerInfo.data.input.refs.leadSource === "Saved"
          ) {
            setFlowDataDirect("TransferQuoteCallBack", "");
          }
          let nextStep = "transfer-quote/" + getFlowDataDirect("pets[0].id");
          if (getFlowDataDirect("holderFirstName")) {
            nextStep = "step-2";
            // nextStep = "custom-cover/" + getFlowDataDirect("pets[0].id");
          }
          gotoStep(nextStep);
        } else if (resultCustomerInfo.errMessage) {
          throw resultCustomerInfo.errMessage;
        }
      } else {
        throw "Load customer error";
      }
    } catch (e) {
      console.log("error - " + e);
      setModalShowSavedQuotePopup(true);
      setLoadingPrice(false);
    }
  }

  async function populateTransferQuoteDetailsMM(mmData: any) {
    let { input, quote } = mmData;
    // console.log("resultCustomerInfo 1: ", mmData);
    let flowDataStore: any = getFlowPathData();
    setFlowDataDirect("pets", []);
    //Set customer information
    setFlowDataDirect("holderFirstName", input.customer.first_name);
    setFlowDataDirect("holderLastName", input.customer.last_name);
    setFlowDataDirect("holderPhone", input.customer.mobile);
    setFlowDataDirect("holderEmail", input.customer.email);

    setFlowDataDirect("refs", input.refs ?? null);

    setFlowDataDirect("holderAddress", {
      line1: input.customer.address,
      suburb: input.customer.suburb,
      state: input.customer.states,
      postcode: input.customer.postcode,
    });
    setFlowDataDirect("sessionId", getGuid());
    setFlowDataDirect("mmSessionId", input.sessionId);
    setFlowDataDirect("quoteNo", input.sessionId);
    setFlowDataDirect("selectedPaymentFrequency", "Fortnightly");
    let findtransferId = input.pets.find((pet: any) => pet.pet_refs && pet.pet_refs.transferId);
    if (findtransferId) {
      setFlowDataDirect("transferId", findtransferId.pet_refs.transferId);
      setFlowDataDirect("TransferQuoteCallBack", "Yes");
    }

    setFlowDataDirect("petQty", input.pets.length);
    setFlowDataDirect("isSavedQuote", true);
    setFlowDataDirect("isChangedData", false);
    let today = moment();
    let promoCode = "";
    let promoCodeData: any = "";
    let countUseSamePromocode = 0;
    input.pets.forEach(async (pet: any, index: number) => {
      // console.log("resultCustomerInfo 2: ", index, pet);
      let petType = pet.pet_type.toLowerCase();
      if (petType == "dog") addNewPet(getFlowDataDirect("pets"), PetType.Dog);
      else addNewPet(getFlowDataDirect("pets"), PetType.Cat);
      let { cover } = pet;
      let dateOfBirth = moment(pet.pet_dob);
      let policyStartDt = moment(pet.policy_start_date);
      if (today > policyStartDt) {
        policyStartDt = today;
      }

      if (pet.promo_code) {
        if (pet.promo_code !== promoCode) {
          promoCode = pet.promo_code;
          countUseSamePromocode = 1;
        } else {
          countUseSamePromocode++;
        }
      }

      const petAge = getPetAge(
        dateOfBirth.format("DD/MM/YYYY"),
        policyStartDt?.format("YYYY-MM-DD") ?? undefined,
      ).days;
      let petAgeCategory = 0; //Standard
      let annualLimit = cover.annual_limit ? cover.annual_limit : 0;
      if (petAge >= 42 && petAge <= 184) {
        if (petType.toLowerCase() === "dog") {
          petAgeCategory = 1; //PUPJ
          annualLimit = Math.ceil(annualLimit / 1.2);
        } else {
          petAgeCategory = 2; //KITJ
          annualLimit = Math.ceil(annualLimit / 1.2);
        }
      } else if (petAge >= 185 && petAge <= 364) {
        if (petType === "dog") {
          petAgeCategory = 3; //PUP
          annualLimit = Math.ceil(annualLimit / 1.1);
        } else {
          petAgeCategory = 4; //KIT
          annualLimit = Math.ceil(annualLimit / 1.1);
        }
      }
      // console.log("policyStartDt", pet.policy_start_date, policyStartDt.format("YYYY-MM-DD"));
      let premiums = quote.pets.find((quotePet: any) => quotePet.pet_no == pet.pet_no);
      // if (premiums && premiums.premiums) {
      //   premiums.premiums.totalPayableBeforeDiscount *=  12;
      // }
      promoCodeData = premiums.promo ?? null;
      let assignedPets = await getFlowDataDirect("pets");
      _.assign(assignedPets[index], {
        pet_no: pet.pet_no || index,
        name: pet.pet_name,
        isValid: false,
        isTouched: true,
        breed: pet.pet_breed,
        petDOB: dateOfBirth.format("YYYY-MM-DD"),
        startDate: policyStartDt.format("YYYY-MM-DD"),
        petSex: pet.pet_sex.toLowerCase(),
        isDesexed: "No",
        petAgeCategory,
        petAgeOnStartDatePolicy: petAge,
        pet_refs: pet.pet_refs ?? {
          callReferenceId: moment().unix().toString(),
        },
        id: getGuid(),
        coverType: "custom",
        customCover: {
          quoteNumber: input.sessionId,
          oldQuote: input.sessionId,
          paymentFrequency: "monthly",
          annualBenefitLimit: annualLimit + "",
          benefitPercentage: cover.benefit_percentage ? cover.benefit_percentage + "" : "0",
          annualExcess: cover.annual_excess ? cover.annual_excess + "" : "0",
          optionalExtras: cover.extra_benefits ? "yes" : "no",
          vetConsultationFees: cover.consultation ? "yes" : "no",
          hasQuote: true,
          premiums: premiums.premiums ?? null,
          promo: premiums.promo ?? null,
          promoCode: pet.promo_code ?? null,
        },
      });
    });
    let pets = getFlowDataDirect("pets");
    let clonedPets = _.cloneDeep(pets);
    setPetOriginalModel(clonedPets);
    setDevState((state) => state + 1);

    setLoadingPrice(true);
    let filteredPromoCode: any = await getPromocode(promoCode.toUpperCase());
    if (filteredPromoCode) {
      let selectedPromotionCode: FlowTypes.IFlowPromotionCode = {
        promoCode: promoCode.toUpperCase(),
        promotionMessage: filteredPromoCode.promotionMessage,
        campaignName: filteredPromoCode.campaignName,
        type: filteredPromoCode.type
          ? parseInt(filteredPromoCode.type.replace("Type", ""))
          : undefined,
        imgSrc: filteredPromoCode.imagePath,
        percent: filteredPromoCode.discount,
        period: filteredPromoCode.period,
        discount: filteredPromoCode.discount,
      };
      setFlowDataDirect("selectedPromoCode", selectedPromotionCode);
      let promoType = promoCodeData.promoType ?? "";
      setFlowDataDirect("promoCode", promoCode.toUpperCase());
      setFlowDataDirect("promoCodeType", parseInt(promoType.replace("Type", "")));
    }
  }

  function populateTransferQuoteDetails(
    customerDetails: FlowTypes.IFlowTransferQuoteCustomerInfo,
    salesJourneyInfo: Array<FlowTypes.IFlowTransferQuote>,
  ) {
    let flowDataStore: any = getFlowPathData();
    setFlowDataDirect("pets", []);

    setFlowDataDirect("transferId", salesJourneyInfo[0].transferId);
    setFlowDataDirect("prePaymentPeriodMonths", salesJourneyInfo[0].prePaymentPeriodMonths);

    setFlowDataDirect("holderFirstName", customerDetails.entityAttributesObject.first_name);
    setFlowDataDirect("holderEmail", customerDetails.entityAttributesObject.email);

    if (
      customerDetails.entityAttributesObject.suburb &&
      customerDetails.entityAttributesObject["postcode_82e7cd60-64ab-482c-8854-16abc2cfa687"] &&
      customerDetails.entityAttributesObject["state_055bfbaa-5add-4e21-8d2a-d19d32fcafcc"]
    ) {
      setFlowDataDirect(
        "holderAddress.postcode",
        customerDetails.entityAttributesObject["postcode_82e7cd60-64ab-482c-8854-16abc2cfa687"],
      );

      setFlowDataDirect("holderAddress.suburb", customerDetails.entityAttributesObject.suburb);

      setFlowDataDirect(
        "holderAddress.state",
        customerDetails.entityAttributesObject["state_055bfbaa-5add-4e21-8d2a-d19d32fcafcc"],
      );
    }

    let dateOfBirth = formatDate(
      salesJourneyInfo[0].insuredEntities[0].entityAttributesObject.date_of_birth.toString(),
    );
    let policyStartDt = formatDate(salesJourneyInfo[0].policyStartDate.toString());
    let petType = salesJourneyInfo[0].insuredEntities[0].entityAttributesObject.pet_type;

    if (petType == "Dog") addNewPet(getFlowDataDirect("pets"), PetType.Dog);
    else addNewPet(getFlowDataDirect("pets"), PetType.Cat);

    setFlowDataDirect("petQty", 1);

    _.assign(getFlowDataDirect("pets")[0], {
      name: salesJourneyInfo[0].insuredEntities[0].entityAttributesObject.pet_name,
      isValid: false,
      isTouched: true,
      breed:
        salesJourneyInfo[0].insuredEntities[0].entityAttributesObject[
          "riskexposure_a5e77b95-2944-4a6d-9b88-834325adb8b3"
        ],
      petDOB: dateOfBirth,
      startDate: policyStartDt,
      petSex: salesJourneyInfo[0].insuredEntities[0].entityAttributesObject.sex.toLowerCase(),
      isDesexed: "No",
      petAgeCategory: 0,
      petAgeOnStartDatePolicy: 1,
      id: getGuid(),
    });

    //gotoStep("step-2");
    setDevState((state) => state + 1);
  }

  function formatDate(dateString: string) {
    if (!dateString) return "";

    let date = new Date();
    if (new Date(dateString).toString() == "Invalid Date") {
      const [day, month, year] = dateString.split("/");
      date = new Date(parseInt(year), parseInt(month), parseInt(day));
    } else {
      date = new Date(dateString);
    }

    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  }

  function handleAddTestData(flowDataStore: any) {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() + 5);

    _.set(flowDataStore, "holderFirstName", "Hung");
    _.set(flowDataStore, "holderLastName", "Kipanga");
    _.set(flowDataStore, "holderAddress", {
      line1: "10 Station Street",
      suburb: "Sydney",
      state: "NSW",
      postcode: "2000",
    });
    _.set(flowDataStore, "holderEmail", "hung@kipanga.com.au");
    _.set(flowDataStore, "holderPhone", "0411222333");
    // _.set(flowDataStore, 'holderDOB', '1980-11-28');

    _.set(flowDataStore, "pets", []);
    addNewPet(flowDataStore.pets, PetType.Dog);
    _.assign(flowDataStore.pets[0], {
      name: "Honey",
      isValid: false,
      isTouched: true,
      breed: "Shih Tzu",
      petDOB: "2021-01-01",
      petAgeCategory: 0,
      petAgeOnStartDatePolicy: 1096,
      startDate: startDate.toISOString().split("T")[0],
      petSex: "male",
      isDesexed: "Yes",
    });
    _.set(flowDataStore, "petQty", 1);
    _.set(flowDataStore, "PetTypeChosenFirst", "dog");
    _.set(flowDataStore, "PetTypesChosen", ["dog"]);

    _.set(flowDataStore, "totalAmounts.allPetNames", "");
    _.set(flowDataStore, "totalAmounts.installmentAmount", "0");
    _.set(flowDataStore, "totalAmounts.installmentBasePremium", "0");
    _.set(flowDataStore, "totalAmounts.installmentBasePremiumPlusGST", "0");
    _.set(flowDataStore, "totalAmounts.installmentStampDuty", "0");
    _.set(flowDataStore, "totalAmounts.installmentPolicyFee", "0");
    _.set(flowDataStore, "totalAmounts.installmentPolicyFeeTotal", "0");
    _.set(flowDataStore, "totalAmounts.totalInstallmentDiscountAmount", "0");
    _.set(flowDataStore, "holderFullName", "");
    _.set(flowDataStore, "holderAddressState", "");
  }

  React.useEffect(() => {
    if (
      location.pathname !== "/step-1" &&
      location.pathname !== "/" &&
      !location.pathname.startsWith("/step-1/")
    ) {
      gotoStep("step-1");
    }
    setFlowDataDirect("prev-slug", location.pathname);
    setFlowDataDirect("totalAmounts.installmentAmount", 0);
    setFlowDataDirect("multiPetPromoCode", "MULTIPET");
    pushDataToGTM("Started Quote", getGTMQuoteData("Get Started"));
  }, []);
  const [loadingPrice, setLoadingPrice] = React.useState(false);
  React.useEffect(TransferQuoteCallBack, []);

  return (
    <>
      <div className="App" key={"ds_" + devState}>
        <FlowProvider>
          <FlowRunner
            appConfig={{
              flowTelemetryEndpoint: appConfig.flow_telemetry_endpoint,
              trackingApiKey: appConfig.trackingApiKey,
              trackingApiUrl: appConfig.trackingApiUrl,
            }}
            flowConfig={flowConfig as Array<FlowTypes.IFlowStep>}
            helperText={helperText as FlowTypes.IFlowHelperTextProps}
            additionalComponents={petsyComponents}
            helpTips={tips}
            recaptchaKey={appConfig.google_site_key}
            onFlowStart={handleFlowStart}
            onAddTestData={handleAddTestData}
          />
        </FlowProvider>
        {/* <Redirect to="/step-1" /> */}
      </div>

      <LoadingLightbox show={loadingPrice} title="Loading your Quote..." />
      {modalShowRefPopup && (
        <PetsyRefPopup show={modalShowRefPopup} onClose={OnClosePoupCallback} />
      )}
      {modalShowIsExpired && (
        <PetsyExpiredPopup
          show={modalShowIsExpired}
          sessionData={sessionData}
          onClose={OnClosePoupCallback}
        />
      )}
      {modalShowRetrieveQuotePopup && (
        <PetsyRetrieveQuotePopup
          show={modalShowRetrieveQuotePopup}
          quoteNumberField={quoteNumberField}
          onClose={OnClosePoupCallbackRetrieveQuote}
        />
      )}
      {modalShowSavedQuotePopup && (
        <PetsySavedQuoteErrorPopup show={modalShowSavedQuotePopup} onClose={OnClosePoupCallback} />
      )}
    </>
  );
}

export default App;
